// extracted by mini-css-extract-plugin
export var box = "SlideWide-module--box--7eff9";
export var box_md = "SlideWide-module--box_md--dd0fc";
export var box_xmd = "SlideWide-module--box_xmd--16468";
export var box_flex = "SlideWide-module--box_flex--88738";
export var box_lg = "SlideWide-module--box_lg--129bf";
export var box_sm = "SlideWide-module--box_sm--bfeee";
export var box_outer = "SlideWide-module--box_outer--2dedc";
export var box_whiteBg = "SlideWide-module--box_white-bg--40617";
export var box_noMarginBottom = "SlideWide-module--box_no-margin-bottom--225f9";
export var box_noPadding = "SlideWide-module--box_no-padding--e087a";
export var box_outerGray = "SlideWide-module--box_outer-gray--7850b";
export var box_dark = "SlideWide-module--box_dark--1ebea";
export var box_zIndex = "SlideWide-module--box_z-index--025c7";
export var box_zIndex6 = "SlideWide-module--box_z-index-6--e815e";
export var box_eventsWithLine = "SlideWide-module--box_events-with-line--0f872";
export var box_featuresAo = "SlideWide-module--box_features-ao--40c00";
export var box_verticalPaddings = "SlideWide-module--box_vertical-paddings--a5b1e";
export var clearP = "SlideWide-module--clearP--7cba3";
export var clearP_vc = "SlideWide-module--clearP_vc--3eb66";
export var slide = "SlideWide-module--slide--117e3";
export var wrapper = "SlideWide-module--wrapper--c2f9d";
export var nameWrapper = "SlideWide-module--nameWrapper--5c295";
export var picture = "SlideWide-module--picture--70d6f";
export var img = "SlideWide-module--img--bb32b";
export var text = "SlideWide-module--text--4e846";
export var link = "SlideWide-module--link--88d9c";
export var linkText = "SlideWide-module--linkText--7c40d";
export var icon = "SlideWide-module--icon--166fc";
export var position = "SlideWide-module--position--20545";
export var description = "SlideWide-module--description--ed759";
export var fadeInAnimation = "SlideWide-module--fadeInAnimation--0ef20";
export var placeHolderShimmer = "SlideWide-module--placeHolderShimmer--b8e66";